export function formatResponseList(list, { cents = [], strnums = [] } = {}) {
  return list.map(data => {
    return formatResponseData(data, { cents, strnums })
  })
}

export function formatResponseData(data, { cents = [], strnums = [] } = {}) {
  Object.keys(data).forEach(key => {
    if (strnums.includes(key) && data[key]) {
      data[key] = Number(data[key])
    }
    if (cents.includes(key) && data[key]) {
      data[key] = Math.round(data[key]) / 100
    }
  })
  return data
}

export function formatRequestData(data, { cents = [], strnums = [] } = {}) {
  data = { ...data }
  Object.keys(data).forEach(key => {
    if (strnums.includes(key) && data[key]) {
      data[key] = String(data[key])
    }
    if (cents.includes(key) && data[key]) {
      data[key] = Math.round(data[key] * 100)
    }
  })
  return data
}

/**
 * 格式化货币字符串
 * @param {string} str 货币字符串
 * @returns {string} 格式化后的货币字符串
 * @example
 * formatCurrencyString('存款1000') // '存款10.00'
 * formatCurrencyString('提款-1000') // '提款-10.00'
 */
export function formatCurrencyString(str) {
  if (!str) return ''
  let result = str

  const numbers = str.match(/\d+(\.\d+)?/g)

  if (numbers && numbers.length > 0) {
    for (const number of numbers) {
      const amountCurrency = formatCurrency(number)
      result = result.replace(number, amountCurrency)
    }
  }
  return result
}

export function formatCurrency(value) {
  if (!value) return '0.00'
  return (value / 100).toFixed(2)
}

export function formatDate(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp * 1000)
  return date.toLocaleString()
}

export function formatNumber(value) {
  if (!value) return '0'
  return Number(value)
}

export function transferCurrency(amount) {
  if (!amount) return 0
  return Math.round(amount * 100)
}

export function transferDate(dateString) {
  const date = new Date(dateString)
  return date.getTime() / 1000
}

export function transferNumber(value) {
  if (!value) return 0
  return Number(value)
}

export const getNumberOptions = () => ({
  rate: {
    style: 'width: 187px',
    max: 1,
    min: 0,
    step: 0.001,
    precision: 4,
  },
  currency: {
    style: 'width: 187px',
    min: 0,
    step: 1,
    precision: 2,
  },
  integer: {
    style: 'width: 187px',
    min: 0,
    step: 1,
    precision: 0,
  },
})

export const formatter = {
  currency: (data, keys) => {
    keys.forEach(field => {
      data[`${field}_original`] = data[field]
      data[field] = formatCurrency(data[field])
    })
    return data
  },
  date: (data, keys) => {
    keys.forEach(field => {
      data[`${field}_original`] = data[field]
      data[field] = formatDate(data[field])
    })
    return data
  },
  number: (data, keys) => {
    keys.forEach(field => {
      data[`${field}_original`] = data[field]
      data[field] = formatNumber(data[field])
    })
    return data
  },
}

export const transfer = {
  currency: (data, keys) => {
    keys.forEach(field => {
      data[field] = transferCurrency(data[field])
    })
    return data
  },
  date: (data, keys) => {
    keys.forEach(field => {
      data[field] = transferDate(data[field])
    })
    return data
  },
  string: (data, keys) => {
    keys.forEach(field => {
      data[field] = String(data[field])
    })
    return data
  },
}

export function copyText(text) {
  // 现代浏览器优先使用 Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    this.$message({
      type: 'success',
      message: '复制成功',
    })
    return navigator.clipboard
      .writeText(text)
      .then(() => true)
      .catch(err => {
        console.error('无法使用Clipboard API:', err)
        return false
      })
  }
  this.$message({
    type: 'danger',
    message: '浏览器不支持复制',
  })
}

export const TZ = {
  india: 'Asia/Kolkata',
  shanghai: 'Asia/Shanghai',
}

export function formatTime(date, TZ = TZ.india) {
  if (!date) return ''
  const formatter = new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: TZ,
  })
  return formatter.format(date)
}

function shouldFilter(key) {
  return key !== null && key !== undefined && key !== ''
}

export function filterQuery(data) {
  return Object.keys(data)
    .filter(key => shouldFilter(data[key]))
    .reduce((acc, cur) => {
      acc[cur] = data[cur]
      return acc
    }, {})
}

export function getStatusText(map, status, defaultText = '') {
  const option = Array.isArray(map) ? map.find(item => item.value === status) : map[status]
  return option?.text || option?.label || defaultText
}

export function getStatusType(map, status, defaultType = '') {
  const option = Array.isArray(map) ? map.find(item => item.value === status) : map[status]
  return option?.type || defaultType
}

export function getOptionsText(options, value, defaultText = '') {
  const option = options.find(item => item.value === value)
  return option?.label || defaultText
}
